import { createSelector } from 'reselect';

export const selectFlyerGibs = (state) => state.flyerGibs.list;

export const selectFlyerGibsFetched = (state) => state.flyerGibs.fetched;

export const selectFlyerGib = (state, id) =>
  createSelector(selectFlyerGibs, (flyerGibs) => {
    return flyerGibs[id] || null;
  })(state);

export const selectFlyerGibButtons = (state, id) =>
  createSelector(
    () => selectFlyerGib(state, id),
    (flyerGib) => flyerGib?.settings?.layout?.buttons || [],
  )(state);

export const selectFlyerGibIdsByPages = (state, pages) => {
  const flyerGibs = selectFlyerGibs(state);
  return Object.values(flyerGibs)
    .filter((gib) => gib.settings?.flyer_page && pages.includes(gib.settings.flyer_page))
    .map((gib) => gib.id);
};
